<template>
  <div v-if="items.length">
    <page-heading>Your Drafts</page-heading>
    <appearances-drafts-header :appearances="appearances" />

    <div v-for="draft in items" :key="draft.id" class="my-drafts-summary__draft mb-3">
      <div class="my-drafts-summary__header">
        <div class="my-drafts-summary__name">{{ draft.name }} ({{ draft.total_noms }})</div>
        <div class="my-drafts-summary__actions">
          <router-link
            :to="{ name: 'Nominations Add', params: { draftId: String(draft.id) } }"
            class="btn btn-primary btn-sm"
          >
            View nominations
          </router-link>
          <app-button
            v-if="draft.invoice_id"
            variant="outline-primary"
            size="sm"
            :block="false"
            :loading="generatingPdfIds.has(draft.invoice_id)"
            @click="viewInvoice(draft.invoice_id)"
          >
            View invoice
          </app-button>
        </div>
      </div>

      <div class="my-drafts-summary__blocks">
        <div v-if="draft.unprocessed" class="my-drafts-summary__block">
          You have ({{ draft.unprocessed }}) nominations currently held and they will be processed by the secretary soon. Please be patient this can take up to three days.
        </div>
        <div v-if="draft.accept_unpaid" class="my-drafts-summary__block">
          You have ({{ draft.accept_unpaid }}) accepted but not yet paid nominations. The secretary will mark your nominations as paid when they receive your payment.
        </div>
        <div v-if="draft.accept_paid" class="my-drafts-summary__block">
          You have ({{ draft.accept_paid }}) accepted and fully paid nominations.
        </div>
        <div v-if="draft.need_to_be_processed" class="my-drafts-summary__block">
          Due to excessive nominations draft restrictions have changed. Please click view nominations to process your nominations.
        </div>
        <div v-if="draft.waitlist" class="my-drafts-summary__block">
          Sorry, due to excessive nominations we couldn't fit you in just yet. Please keep checking your nominations if space opens up we will try our best to fit you in!
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from '@vue/composition-api'
import PageHeading from '@/components/PageHeading'
import AppButton from '@/components/AppButton'
import AppearancesDraftsHeader from '@/views/Leaders/Listing/components/AppearancesDraftsHeader'
import invoicesApi from '@/services/api/invoices'
import useMyDraftsSummary from '@/composables/nominations/useMyDraftsSummary'

export default defineComponent({
  name: 'MyDraftsSummary',
  components: {
    PageHeading,
    AppButton,
    AppearancesDraftsHeader
  },
  props: {
    appearances: {
      type: Object,
      required: true
    }
  },
  setup(props, { emit }) {
    const { items, fetch } = useMyDraftsSummary()
    const generatingPdfIds = ref(new Set())

    watch(items, val => emit('has-items', val.length > 0))

    onMounted(() => fetch())

    async function viewInvoice(invoiceId) {
      if (generatingPdfIds.value.has(invoiceId)) return
      generatingPdfIds.value = new Set([...generatingPdfIds.value, invoiceId])
      try {
        const res = await invoicesApi.getPdf(invoiceId)
        const url = res.data.data.url
        if (!url) return
        window.open(url, '_blank')
      } catch (_err) {
        // ошибки обрабатываются глобально через http.js interceptor
      } finally {
        const next = new Set(generatingPdfIds.value)
        next.delete(invoiceId)
        generatingPdfIds.value = next
      }
    }

    return { items, generatingPdfIds, viewInvoice }
  }
})
</script>

<style scoped>
.my-drafts-summary__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.my-drafts-summary__name {
  font-weight: 600;
}

.my-drafts-summary__actions {
  display: flex;
  gap: 8px;
}

.my-drafts-summary__blocks {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.my-drafts-summary__block {
  margin: 0;
  padding: 10px 20px 10px 35px;
  border: 1px solid #61c0cf;
  border-radius: 0.25rem;
  color: #0e616e;
  background-color: #bee5eb;
  letter-spacing: 1px;
}
</style>



// WEBPACK FOOTER //
// src/views/Nominations/components/MyDraftsSummary.vue